enum UploadMode {
  SINGLE = 'single',
  BULK = 'bulk',
}

export default UploadMode;
